import { render } from "./BasicExpenseReport.vue?vue&type=template&id=57596fd6&scoped=true"
import script from "./BasicExpenseReport.vue?vue&type=script&lang=js"
export * from "./BasicExpenseReport.vue?vue&type=script&lang=js"

import "./BasicExpenseReport.vue?vue&type=style&index=0&id=57596fd6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57596fd6"]])

export default __exports__